import React from 'react';
import { Checkbox, Grid, Stack, Text } from 'library/ui';
import { Role } from './models';

interface ISelectPermissionsProps {
    selectedRoles: number[];
    onRoleSelect: (id: number) => void;
    availableRoles: Role[];
}

export default function SelectRoles({ selectedRoles, onRoleSelect, availableRoles }: ISelectPermissionsProps) {
    return (
        <Stack gap="sm">
            <Text weight="semibold">Select Roles</Text>
            <Grid columns={2} gap="sm" collapseAt="sm">
                {availableRoles.map((x) => (
                    <Checkbox
                        key={x.id}
                        label={x.display_name}
                        checked={selectedRoles.includes(x.id)}
                        onChange={() => onRoleSelect(x.id)}
                    />
                ))}
            </Grid>
        </Stack>
    );
}
